/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-21 15:14:25
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-22 21:34:07
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileLibrary/Components/Card/index.tsx
 */
import React from 'react';
import classname from 'classnames';
import { Col, Tooltip, Progress } from 'antd';

import { Checkbox } from '@/src/components/Antd';
import { Icon } from '@/src/tools/icon';
import { MediaFile } from '@/src/types/common/media';
import { getFileExt, transSizeToKB } from '@/src/tools/helper';

import styles from './style.module.less';
import { UPLOAD_VIDEO } from '@/src/tools/constant';

type Props = {
  loading: boolean;
  percent: number;
  file: MediaFile;
  checked: boolean;
  onNavigateToDetail: (uuid: string) => void;
  onDelete: (uuids: string[]) => void;
  onClick: (uuid: string) => void;
};

function Card({
  loading,
  percent,
  file,
  checked,
  onNavigateToDetail,
  onDelete,
  onClick,
}: Props) {
  const thumbnailImage = file.url;
  const ext = getFileExt(file.originalName);
  return (
    <Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={4}>
      {loading ? (
        <div className={styles.progress}>
          <div className={styles.percent}>
            <Progress
              type='circle'
              percent={percent}
              width={30}
              showInfo={false}
            />
          </div>
        </div>
      ) : (
        <div
          onClick={onClick.bind(this, file.uuid)}
          className={classname(styles.container, { [styles.checked]: checked })}
          style={{
            backgroundImage: thumbnailImage
              ? `url('${thumbnailImage}')`
              : undefined,
          }}>
          {UPLOAD_VIDEO.indexOf(ext) !== -1 && (
            <Icon type='iconvideo' className={styles.video} />
          )}
          <div className={styles.info}>
            <Tooltip title={file.originalName}>
              <div className={styles.name}>{file.originalName}</div>
            </Tooltip>
            <div className={styles.bottom}>
              <span className={styles.size}>{transSizeToKB(file.size)}</span>
              <span className={styles.iconSet}>
                <Icon
                  type='iconedit1'
                  className={styles.icon}
                  onClick={(e) => {
                    e.stopPropagation();
                    onNavigateToDetail(file.uuid);
                  }}
                />
                <Icon
                  type='icondelete1'
                  className={styles.icon}
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete([file.uuid]);
                  }}
                />
              </span>
            </div>
          </div>
          <div className={styles.checkbox}>
            <Checkbox checked={checked} className={styles.check} />
          </div>
        </div>
      )}
    </Col>
  );
}

export default Card;
